export default {
  OK: "Được rồi",
  ok: "Được rồi",
  loginFailed: "Đăng nhập không thành công, vui lòng thử lại.",
  requestFailed: "Yêu cầu không thành công, vui lòng kiểm tra kết nối internet của bạn.",
  invalidLogin: "Tên người dùng hoặc mật khẩu không hợp lệ.",
  thisFunctionExists: "Chức năng này đã tồn tại.",
  thisFunctionNotAllowDelete: "Chức năng này không được phép xóa.",
  thisFunctionNotExists: "Chức năng này không tồn tại.",
  targetFunctionIdRequired: "ID chức năng mục tiêu là bắt buộc.",
  thisPageExists: "Trang này đã tồn tại.",
  thisPageNotAllowDelete: "Trang này không được phép xóa.",
  thisRoleExists: "Vai trò này đã tồn tại.",
  thisRoleNotAllowDelete: "Vai trò này không được phép xóa.",
  targetRoleIdRequired: "ID vai trò mục tiêu là bắt buộc.",
  invalidParameter: "Tham số không hợp lệ.",
  systemError: "Hệ thống không thể xử lý yêu cầu của bạn.",
  spErrorMessage: "Lỗi thông báo SP (Phụ thuộc vào lỗi nào).",
  actionbyRequired: "Người dùng hiện tại là bắt buộc.",
  sessionTokenRequired: "Session Token là bắt buộc.",
  functionIdRequired: "ID chức năng là bắt buộc.",
  functionNameRequired: "Tên chức năng là bắt buộc.",
  newFunctionNameRequired: "Tên chức năng là bắt buộc.",
  pageIdRequired: "ID trang là bắt buộc.",
  newPageIdRequired: "ID trang là bắt buộc.",
  newPageNameRequired: "Tên trang là bắt buộc.",
  targetPageIdRequired: "ID trang mục tiêu là bắt buộc.",
  passwordRequired: "Mật khẩu là bắt buộc.",
  userNameRequired: "Tên đầy đủ là bắt buộc.",
  passwordValidation: "Mật khẩu phải gồm 6-20 ký tự và là sự kết hợp của (các) số và (các) chữ cái.",
  pageNumRequired: "Số trang là bắt buộc.",
  pageSizeRequired: "Kích thước trang là bắt buộc.",
  roleIdRequired: "ID vai trò là bắt buộc",
  oldPasswordRequired: "Mật khẩu hiện tại là bắt buộc.",
  userStatusRequired: "Trạng thái người dùng là bắt buộc.",
  newRoleIdRequired: "ID vai trò là bắt buộc.",
  newRoleNameRequired: "Tên vai trò là bắt buộc.",
  startDateIsGteEndDate: "Ngày bắt đầu lớn hơn Ngày kết thúc.",
  thisRoleNotExists: "Vai trò này không tồn tại.",
  thisPageNotExists: "Trang này không tồn tại.",
  thisUserExists: "Người dùng này đã tồn tại.",
  thisUserNotExists: "Người dùng này không tồn tại.",
  thisUserBlackListed: "Tài khoản của bạn đã bị tạm ngưng.",
  thisUserInactive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  thisUserBlocked: "Tài khoản của bạn đã bị chặn.",
  thisUserNotActive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  InvalidPageFunction: "Chức năng trang không hợp lệ.",
  invalidUser: "Người dùng không hợp lệ!",
  invalidToken: "Phiên không hợp lệ!",
  NoUserAccessRight: "Giấy phép bị từ chối!",
  connection: "Lỗi kết nối",
  profileIdRequired: "ID hồ sơ là bắt buộc.",
  packageIdRequired: "ID gói là bắt buộc.",
  fullNameMinThreeChar: "Họ và tên phải có ít nhất 3 ký tự.",
  accountIdMinThreeChar: "ID tài khoản phải có ít nhất 3 ký tự.",
  searchCriteriaRequired: "Tiêu chí tìm kiếm là bắt buộc.",
  affiliateIdRequired: "ID đại lý là bắt buộc.",
  minDepositRequired: "Yêu cầu đặt cọc tối thiểu.",
  bonusRateRequired: "Tỷ lệ tiền thưởng là bắt buộc.",
  onlyAllowRejectDeposit: "Chỉ cho phép từ chối vé đặt cọc.",
  senderBankIdRequired: "Cần có ID ngân hàng người gửi.",
  senderBankAccNoRequired: "Ngân hàng người gửi acc không. là bắt buộc.",
  minFTDAmtNumOnly: "Min. FTD Amt chỉ chấp nhận số.",
  maxFTDAmtNumOnly: "Tối đa FTD Amt chỉ chấp nhận số.",
  crmBasicCriteriaRequired: "Cần có ID thành viên / Điện thoại liên hệ / Email liên hệ / Ngày đăng ký / Ngày đăng nhập cuối cùng.",
  verifiedDateRangeAllowThreeMonths: "Phạm vi ngày đăng ký chỉ cho phép chọn tối đa 3 tháng.",
  lastLoginDateRangeAllowThreeMonths: "Phạm vi ngày đăng nhập cuối cùng chỉ cho phép chọn tối đa 3 tháng.",
  depositDateRangeAllowThreeMonths: "Phạm vi ngày gửi tiền chỉ cho phép chọn tối đa 3 tháng.",
  ftdDateRangeAllowThreeMonths: "Phạm vi ngày FTD chỉ cho phép chọn tối đa 3 tháng.",
  ltdDateRangeAllowThreeMonths: "Phạm vi ngày LTD chỉ cho phép chọn tối đa 3 tháng.",
  lastLoginDateEarlierThanVerifiedDate: "Ngày đăng nhập cuối cùng sớm hơn ngày đăng ký.",
  depositDateEarlierThanVerifiedDate: "Ngày gửi tiền sớm hơn ngày đăng ký.",
  ftdDateEarlierThanVerifiedDate: "Ngày FTD sớm hơn ngày đăng ký.",
  ltdDateEarlierThanVerifiedDate: "Ngày LTD sớm hơn ngày đăng ký.",
  ftdFromRequired: "FTD kể từ ngày là bắt buộc.",
  ftdToRequired: "FTD cho đến nay là bắt buộc.",
  ltdFromRequired: "LTD từ ngày là bắt buộc.",
  ltdToRequired: "LTD cho đến nay là bắt buộc.",
  failedToLaunchPaymentGateway: "Không khởi chạy được cổng thanh toán.",
  enTitleRequired: "Tiêu đề EN là bắt buộc.",
  enBodyRequired: "Cơ thể EN là bắt buộc.",
  enImageUrlRequired: "Url hình ảnh EN là bắt buộc.",
  enImageUrlDesktopRequired: "EN Desktop Image Url là bắt buộc.",
  enAltRequired: "EN Alt là bắt buộc.",
  enHrefRequired: "EN Href là bắt buộc.",
  resubmitTicketRequired: "Yêu cầu gửi lại vé.",
  withtholdBonusAndAmountGreaterThanZero: "Tiền thưởng khấu lưu và số tiền khấu lưu không được lớn hơn 0 cùng một lúc.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Số tiền rút tối đa và số tiền rút tối đa không được lớn hơn 0 cùng một lúc.",
  serverBusy: "Máy chủ hiện đang bận. Vui lòng thử lại.",
  isRequired: "Vui lòng nhập {fname}.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isMaxValue: "{fname} phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} ký tự.",
  isMaxLength: "{fname} phải nhỏ hơn hoặc bằng các ký tự {fvalue}.",
  isAlpha: "{fname} chỉ chấp nhận bảng chữ cái.",
  isAlphaNum: "{fname} chỉ chấp nhận chữ và số.",
  isNumeric: "{fname} chỉ chấp nhận số.",
  isEmail: "{fname} chỉ chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} chỉ chấp nhận địa chỉ IPv4 hợp lệ.",
  isSameAs: "{fname} phải giống với {fname2}.",
  isUrl: "{fname} chỉ chấp nhận URL.",
  containAlphaNum: "{fname} phải có ít nhất một bảng chữ cái và một số.",
  alphaNumWithSpace: "{fname} chỉ chấp nhận chữ và số.",
  isDecimal: "{fname} chỉ chấp nhận số.",
  isInteger: "{fname} chỉ chấp nhận số nguyên.",
  selectOption: "Vui lòng chọn một {fname}",
  notSameAs: "{fname} và {fname2} không thể giống nhau.",
  dateRangeAllowOneMonth: "Phạm vi ngày chỉ cho phép chọn tối đa 1 tháng.",
  dateRangeAllowOneYear: "Phạm vi ngày chỉ cho phép chọn tối đa 1 năm.",
  greaterThanZero: "{fname} phải lớn hơn không.",
  atLeastOneAuthority: "Phải chọn ít nhất một cơ quan có thẩm quyền.",
  BLOCK: "Tài khoản của bạn đã bị chặn.",
  SUSPEND: "Tài khoản của bạn đã bị tạm ngưng.",
  CLOSE: "Tài khoản của bạn đã bị đóng.",
  RESETL: "Tài khoản của bạn đã được đặt lại.",
  atLeastOneProvider: "Phải chọn ít nhất một nhà cung cấp.",
  failedToGetResultUrl: "Không nhận được url kết quả.",
  fileSizeValidation: "Quá lớn, kích thước tối đa cho phép là 1mb",
  atLeastOnePaymentOption: "Phải chọn ít nhất một tùy chọn thanh toán.",
  atLeastOnePaymentGateway: "Phải chọn ít nhất một cổng thanh toán.",
  dateRangeAllow31Days: "Phạm vi ngày chỉ cho phép chọn tối đa 31 ngày.",
  dateRangeAllow31Months: "Phạm vi ngày chỉ cho phép chọn tối đa 31 tháng.",
  dateRangeAllow31Years: "Phạm vi ngày chỉ cho phép chọn tối đa 31 năm.",
  invalidCategory: "Danh mục không hợp lệ.",
  noChanges: "Không có thay đổi.",
  permissionDenied: "Quyền bị từ chối.",
  referralCodeRequired: "Mã giới thiệu là bắt buộc.",
  providerDescRequired: "Mô tả nhà cung cấp là bắt buộc.",
  marqueeContentRequired: "Nội dung Marquee là bắt buộc.",
  bonusNameRequired: "Tên tiền thưởng là bắt buộc.",
  baseAmountRequired: "Số tiền cơ bản là bắt buộc.",
  reviewIdRequired: "ID đánh giá là bắt buộc.",
  surveyIdRequired: "ID khảo sát là bắt buộc.",
  questionRequired: "Câu hỏi là bắt buộc.",
  iframeIdRequired: "ID Iframe là bắt buộc.",
  bonusAmountRequired: "Số tiền thưởng là bắt buộc.",
  inboxIdRequired: "Cần có ID hộp thư đến.",
  exchangedAmountRequired: "Số tiền đổi là bắt buộc.",
  baseRateRequired: "Lãi suất cơ bản là bắt buộc.",
  exchangeRateRequired: "Tỷ giá hối đoái là bắt buộc.",
  baseCurrencyRequired: "Tiền tệ cơ sở là bắt buộc.",
  exchangeCurrencyRequired: "Tiền hối đoái là bắt buộc.",
  depositTypeRequired: "Loại tiền gửi là bắt buộc.",
  nbRedepositRequired: "Nb gửi lại là bắt buộc.",
  bankOwnerRequired: "Chủ ngân hàng là bắt buộc.",
  autoSenderRequired: "Người gửi tự động là bắt buộc.",
  isRecommendRequired: "Đề xuất là bắt buộc.",
  recipientBankIdRequired: "Cần có ID ngân hàng người nhận.",
  recipientBankAccNoRequired: "Bắt buộc phải có số tài khoản ngân hàng của người nhận.",
  accountBalanceRequired: "Số dư tài khoản là bắt buộc.",
  incomingAmountThresholdRequired: "Ngưỡng số tiền đến là bắt buộc.",
  incomingFrequencyThresholdRequired: "Ngưỡng tần số đến là bắt buộc.",
  outgoingAmountThresholdRequired: "Ngưỡng số tiền đi là bắt buộc.",
  outgoingFrequencyThresholdRequired: "Ngưỡng tần suất đi là bắt buộc.",
  bankAccTypeRequired: "Loại tài khoản ngân hàng là bắt buộc.",
  packageRequired: "Gói là bắt buộc.",
  rtpRequired: "RTP là bắt buộc.",
  domainIdRequired: "ID miền là bắt buộc.",
  buyOnBehalfRequired: "Mua thay mặt là bắt buộc.",
  serviceProviderRequired: "Nhà cung cấp dịch vụ là bắt buộc.",
  serverAccountRequired: "Tài khoản máy chủ là bắt buộc.",
  nameServerRequired: "Máy chủ định danh là bắt buộc.",
  socialLinkRequired: "Liên kết xã hội là bắt buộc.",
  newSocialPlatformRequired: "Cần có nền tảng xã hội mới.",
  attachmentPathRequired: "Đường dẫn đính kèm là bắt buộc.",
  depositMethodRequired: "Phương thức gửi tiền là bắt buộc.",
  depositDateRequired: "Ngày gửi tiền là bắt buộc.",
  refNoRequired: "Số tham chiếu là bắt buộc.",
  withdrawalAmountRequired: "Số tiền rút là bắt buộc.",
  targetBankAccNoRequired: "Số tài khoản ngân hàng mục tiêu là bắt buộc.",
  targetBankIdRequired: "Cần có ID ngân hàng mục tiêu.",
  jsonRatingRequired: "Xếp hạng JSON là bắt buộc.",
  startTimeRequired: "Thời gian bắt đầu là bắt buộc.",
  accountIdRequired: "ID tài khoản là bắt buộc.",
  parentIdRequired: "Cần có ID phụ huynh.",
  amountRequired: "Số tiền là bắt buộc.",
  clientIpRequired: "IP máy khách là bắt buộc.",
  auditByRequired: "Kiểm toán là bắt buộc.",
  systemTypeRequired: "Loại hệ thống là bắt buộc.",
  currencyRequired: "Tiền tệ là bắt buộc.",
  ipAddressRequired: "Địa chỉ IP là bắt buộc.",
  affiliateCodeRequired: "Mã đại lý là bắt buộc.",
  contactPhoneRequired: "Điện thoại liên hệ là bắt buộc.",
  requestTypeRequired: "Loại yêu cầu là bắt buộc.",
  securityDisabledRequired: "Bảo mật bị vô hiệu hóa là bắt buộc.",
  gameCodeRequired: "Mã trò chơi là bắt buộc.",
  seqRequired: "Trình tự là bắt buộc.",
  minLimitRequired: "Giới hạn tối thiểu là bắt buộc.",
  maxLimitRequired: "Giới hạn tối đa là bắt buộc.",
  commSportsRequired: "Ủy ban cho thể thao là bắt buộc.",
  commSlotsRequired: "Hoa hồng cho các vị trí là bắt buộc.",
  commLivecasinoRequired: "Hoa hồng cho sòng bạc trực tiếp là bắt buộc.",
  commCockfightRequired: "Cần có hoa hồng chọi gà.",
  commOthersRequired: "Ủy ban cho người khác là bắt buộc.",
  settingValueRequired: "Giá trị cài đặt là bắt buộc.",
  vipIdRequired: "Cần có ID VIP.",
  carryOverRequired: "Bắt buộc phải chuyển tiếp.",
  campaignIdRequired: "ID chiến dịch là bắt buộc.",
  titleRequired: "Tiêu đề là bắt buộc.",
  bodyRequired: "Cơ thể là bắt buộc.",
  itemOrderRequired: "Thứ tự mặt hàng là bắt buộc.",
  imageUrlRequired: "URL hình ảnh là bắt buộc.",
  bannerIdRequired: "ID biểu ngữ là bắt buộc.",
  directionRequired: "Hướng dẫn là bắt buộc.",
  defaultOrderRequired: "Thứ tự mặc định là bắt buộc.",
  altRequired: "Văn bản thay thế là bắt buộc.",
  hrefRequired: "Href là bắt buộc.",
  targetWindowRequired: "Cửa sổ mục tiêu là bắt buộc.",
  loginRequiredRequired: "Yêu cầu đăng nhập là bắt buộc.",
  activeFromRequired: "Hoạt động từ là bắt buộc.",
  activeToRequired: "Hoạt động là bắt buộc.",
  bannerTypeRequired: "Loại biểu ngữ là bắt buộc.",
  pageNameRequired: "Tên trang là bắt buộc.",
  remarkRequired: "Nhận xét là bắt buộc.",
  settingKeyRequired: "Phím cài đặt là bắt buộc.",
  memberListRequired: "Danh sách thành viên là bắt buộc.",
  memberIdRequired: "ID thành viên là bắt buộc.",
  workingMonthRequired: "Tháng làm việc là bắt buộc.",
  workingDateRequired: "Ngày làm việc là bắt buộc.",
  tacRequired: "Điều khoản và điều kiện là bắt buộc.",
  paymentModeRequired: "Phương thức thanh toán là bắt buộc.",
  newPasswordRequired: "Mật khẩu mới là bắt buộc.",
  loginIdRequired: "ID đăng nhập là bắt buộc.",
  securityTagRequired: "Thẻ bảo mật là bắt buộc.",
  securityCodeRequired: "Mã bảo mật là bắt buộc.",
  providerCodeRequired: "Mã nhà cung cấp là bắt buộc.",
  startDateRequired: "Ngày bắt đầu là bắt buộc.",
  endDateRequired: "Ngày kết thúc là bắt buộc.",
  searchIdRequired: "ID tìm kiếm là bắt buộc.",
  authTokenRequired: "Mã thông báo xác thực là bắt buộc.",
  newStatusRequired: "Trạng thái mới là bắt buộc.",
  actionRequired: "Hành động là bắt buộc.",
  promotionIdRequired: "Mã khuyến mãi là bắt buộc.",
  promotionNameRequired: "Tên chương trình khuyến mãi là bắt buộc.",
  rolloverRequired: "Bắt buộc phải chuyển đổi.",
  criteriaRequired: "Tiêu chí là bắt buộc.",
  ticketIdRequired: "Cần có ID vé.",
  resultIdRequired: "ID kết quả là bắt buộc.",
  bankIdRequired: "Cần có ID ngân hàng.",
  bankAccNoRequired: "Số tài khoản ngân hàng là bắt buộc.",
  bankAccHolderRequired: "Bắt buộc phải có chủ tài khoản ngân hàng.",
  newBankIdRequired: "Cần có ID ngân hàng mới.",
  newBankAccNoRequired: "Cần có số tài khoản ngân hàng mới.",
  newBankAccHolderRequired: "Cần có chủ tài khoản ngân hàng mới.",
  fullNameRequired: "Tên đầy đủ là bắt buộc.",
  depositAmountRequired: "Số tiền đặt cọc là bắt buộc.",
  gatewayAccRequired: "Tài khoản cổng là bắt buộc.",
  labelNameRequired: "Tên nhãn là bắt buộc.",
  labelIdRequired: "ID nhãn là bắt buộc.",
  bankTypeRequired: "Loại ngân hàng là bắt buộc.",
  amountLimitRequired: "Giới hạn số tiền là bắt buộc.",
  currencyRateRequired: "Tỷ giá tiền tệ là bắt buộc.",
  urlRequired: "URL là bắt buộc.",
  cashRequired: "Tiền mặt là bắt buộc.",
  csRequired: "Hỗ trợ khách hàng là bắt buộc.",
  vipNameRequired: "Tên VIP là bắt buộc.",
  campaignNameRequired: "Tên chiến dịch là bắt buộc.",
  transferIdRequired: "Cần có ID chuyển.",
  betTimeRequired: "Thời gian đặt cược là bắt buộc.",
  turnoverRequired: "Doanh thu là bắt buộc.",
  payoutRequired: "Thanh toán là bắt buộc.",
  winloseRequired: "Thắng/Thua là bắt buộc.",
  rawMessageRequired: "Tin nhắn thô là bắt buộc.",
  authStatusRequired: "Trạng thái xác thực là bắt buộc.",
  dateRequired: "Ngày là bắt buộc.",
  betIdRequired: "ID đặt cược là bắt buộc.",
  betStatusRequired: "Trạng thái đặt cược là bắt buộc.",
  betAmountRequired: "Số tiền đặt cược là bắt buộc.",
  isParlayRequired: "Cược xiên là bắt buộc.",
  isAddonRequired: "Có phải addon là bắt buộc.",
  withholdBonusRequired: "Tiền thưởng giữ lại là bắt buộc.",
  withholdAmountRequired: "Số tiền khấu lưu là bắt buộc.",
  maxWithdrawAmountRequired: "Số tiền rút tối đa là bắt buộc.",
  betTypeRequired: "Loại cược là bắt buộc.",
  maxWithdrawMultipleRequired: "Cần có bội số rút tối đa.",
  socialPlatformRequired: "Nền tảng xã hội là bắt buộc.",
  vipProviderRebateRequired: "Yêu cầu giảm giá của nhà cung cấp VIP.",
  selfRebateRateRequired: "Bắt buộc phải có tỷ lệ tự hoàn tiền.",
  downlineRebateRateRequired: "Cần có tỷ lệ chiết khấu tuyến dưới.",
  tierIdRequired: "Cấp ID là bắt buộc.",
  rebateRateRequired: "Tỷ lệ chiết khấu là bắt buộc.",
  paymentGatewayRequired: "Cổng thanh toán là bắt buộc.",
  rescueIdRequired: "Cần có ID cứu hộ.",
  rescueNameRequired: "Tên cứu hộ là bắt buộc.",
  rescueCycleRequired: "Chu kỳ cứu hộ là bắt buộc.",
  minLoseRequired: "Yêu cầu thua tối thiểu.",
  rescueRateRequired: "Tỷ lệ cứu hộ là bắt buộc.",
  maxPayoutRequired: "Yêu cầu thanh toán tối đa.",
  payoutMethodRequired: "Phương thức thanh toán là bắt buộc.",
  targetGroupRequired: "Nhóm mục tiêu là bắt buộc.",
  maintainDepositRequired: "Duy trì tiền gửi là bắt buộc.",
  maintainTurnoverRequired: "Duy trì doanh thu là bắt buộc.",
  depositOrTurnoverRequired: "Tiền gửi hoặc doanh thu là bắt buộc.",
  maintainDepositOrMaintainTurnoverRequired: "Duy trì tiền gửi hoặc duy trì doanh thu là bắt buộc.",
  vipListRequired: "Danh sách VIP là bắt buộc.",
  gameNameRequired: "Tên trò chơi là bắt buộc.",
  claimTypeRequired: "Loại yêu cầu là bắt buộc.",
  operatorIdRequired: "ID nhà điều hành là bắt buộc.",
  maxBonusRequired: "Tiền thưởng tối đa là bắt buộc.",
  endTimeRequired: "Thời gian kết thúc là bắt buộc.",
  mondayRequired: "Thứ Hai là bắt buộc.",
  tuesdayRequired: "Thứ Ba là bắt buộc.",
  wednesdayRequired: "Thứ Tư là bắt buộc.",
  thursdayRequired: "Thứ Năm là bắt buộc.",
  fridayRequired: "Thứ Sáu là bắt buộc.",
  saturdayRequired: "Thứ bảy là bắt buộc.",
  sundayRequired: "Chủ nhật là bắt buộc.",
  promotionTypeRequired: "Loại khuyến mãi là bắt buộc.",
  claimLimitRequired: "Giới hạn yêu cầu bồi thường là bắt buộc.",
  bonusRate1Required: "Tỷ lệ thưởng 1 là bắt buộc.",
  bonusRate1To2Required: "Tỷ lệ thưởng từ 1 đến 2 là bắt buộc.",
  bonusRate1To3Required: "Tỷ lệ tiền thưởng từ 1 đến 3 là bắt buộc.",
  bonusRate1To4Required: "Tỷ lệ thưởng từ 1 đến 4 là bắt buộc.",
  bonusRate1To5Required: "Cần có tỷ lệ thưởng từ 1 đến 5.",
  bonusRate1To6Required: "Cần có tỷ lệ thưởng từ 1 đến 6.",
  bonusRate1To7Required: "Tỷ lệ thưởng từ 1 đến 7 là bắt buộc.",
  externalIdRequired: "Cần có ID bên ngoài.",
  opsiteRequired: "Opsite là bắt buộc.",
  opsiteContentRequired: "Nội dung Opsite là bắt buộc.",
  opsiteLanguageRequired: "Ngôn ngữ đối lập là bắt buộc.",
  opsitePaymentRequired: "Thanh toán đối lập là bắt buộc.",
  opsiteProviderRequired: "Nhà cung cấp dịch vụ Opsite là bắt buộc.",
  opsiteProviderGamesRequired: "Trò chơi của nhà cung cấp đối tác là bắt buộc.",
  accountTypeRequired: "Loại tài khoản là bắt buộc.",
  domainNameRequired: "Tên miền là bắt buộc.",
  settledTimeRequired: "Thời gian giải quyết là bắt buộc.",
  validTurnoverRequired: "Doanh thu hợp lệ là bắt buộc.",
  resultTimeRequired: "Thời gian kết quả là bắt buộc.",
  resultStatusRequired: "Trạng thái kết quả là bắt buộc.",
  secondIdRequired: "Cần có ID thứ hai.",
  domainListRequired: "Danh sách tên miền là bắt buộc.",
  domainTypeRequired: "Loại tên miền là bắt buộc.",
  moduleRequired: "Mô-đun là bắt buộc.",
  gameIdRequired: "ID trò chơi là bắt buộc.",
  gameDetailRequired: "Chi tiết trò chơi là bắt buộc.",
  bonusRate1To8Required: "Cần có tỷ lệ thưởng từ 1 đến 8.",
  bonusRate1To9Required: "Cần có tỷ lệ thưởng từ 1 đến 9.",
  bonusRate1To10Required: "Cần có tỷ lệ thưởng từ 1 đến 10.",
  invalidOrder: "Đơn hàng không hợp lệ.",
  bannerNotExists: "Biểu ngữ không tồn tại.",
  invalidBannerType: "Loại biểu ngữ không hợp lệ.",
  pageNameExists: "Tên trang tồn tại.",
  pageNotExists: "Trang không tồn tại.",
  tacIsValid: "OTP hợp lệ.",
  invalidTac: "OTP không hợp lệ.",
  tacExpired: "OTP đã hết hạn.",
  tacNotValidate: "OTP chưa được xác thực.",
  paymentModeNotExists: "Phương thức thanh toán không tồn tại.",
  paymentOptionProviderNotExists: "Nhà cung cấp tùy chọn thanh toán không tồn tại.",
  ipAddressExists: "Địa chỉ IP tồn tại.",
  ticketProcessed: "Vé đã được xử lý.",
  bankAccountNotExists: "Tài khoản ngân hàng không tồn tại.",
  bankAccountInactive: "Tài khoản ngân hàng không hoạt động.",
  bankMemberNotExists: "Thành viên ngân hàng không tồn tại.",
  bankMemberInactive: "Thành viên ngân hàng không hoạt động.",
  affiliateExists: "Đặc vụ tồn tại.",
  contactPhoneExists: "Điện thoại liên lạc tồn tại.",
  affiliateFull: "Đặc vụ đầy.",
  uplineInactive: "Đường lên không hoạt động.",
  applicationProcessed: "Đơn đăng ký đã được xử lý.",
  tacValidated: "Điều khoản và điều kiện đã được xác nhận.",
  applicationPending: "Đơn đang chờ xử lý.",
  favouriteGameExists: "Trò chơi yêu thích tồn tại.",
  invalidLimit: "Giới hạn không hợp lệ.",
  settingNotSet: "Cài đặt không được đặt.",
  domainNameNotExists: "Tên miền không tồn tại.",
  domainNameFull: "Tên miền đầy đủ.",
  domainNameNotAvailable: "Tên miền không khả dụng.",
  domainNameExists: "Tên miền tồn tại.",
  subAccountNotExists: "Tài khoản phụ không tồn tại.",
  settingNotExists: "Cài đặt không tồn tại.",
  invalidContactEmail: "Email liên hệ không hợp lệ.",
  accountInactive: "Tài khoản không hoạt động.",
  campaignNotExists: "Chiến dịch không tồn tại.",
  paymentProviderNotExists: "Nhà cung cấp dịch vụ thanh toán không tồn tại.",
  profileInactive: "Hồ sơ không hoạt động.",
  minWithdrawalNotMet: "Số tiền rút tối thiểu không được đáp ứng.",
  invalidBankId: "ID ngân hàng không hợp lệ.",
  bankAccountExists: "Tài khoản ngân hàng tồn tại.",
  bankAccountFull: "Tài khoản ngân hàng đầy.",
  bankAccHolderNotSame: "Chủ tài khoản ngân hàng không giống nhau.",
  exceedMaxWithdrawal: "Vượt quá số tiền rút tối đa.",
  exceedWithdrawalFrequency: "Vượt quá tần suất rút tiền.",
  invalidPackage: "Gói không hợp lệ.",
  promotionNotAvailable: "Không có chương trình khuyến mãi.",
  ongoingPromotion: "Khuyến mãi đang diễn ra.",
  pendingResultInGame: "Kết quả đang chờ xử lý trong trò chơi.",
  labelNameExists: "Tên nhãn tồn tại.",
  labelNotExists: "Nhãn không tồn tại.",
  invalidFtdMin: "Khoản tiền gửi lần đầu không hợp lệ tối thiểu.",
  invalidFtdMax: "Tiền gửi lần đầu không hợp lệ tối đa.",
  ftdMinGtFtdMax: "Khoản tiền gửi lần đầu tối thiểu lớn hơn mức tối đa.",
  vipFull: "VIP đầy.",
  invalidRewardType: "Loại phần thưởng không hợp lệ.",
  vipExists: "VIP tồn tại.",
  vipNotExists: "VIP không tồn tại.",
  onlyOneMaxWithdrawSetting: "Chỉ cho phép một cài đặt rút tiền tối đa.",
  onlyOneWithholdSetting: "Chỉ cho phép một cài đặt giữ lại.",
  campaignExists: "Chiến dịch tồn tại.",
  vipProviderNotExists: "Nhà cung cấp VIP không tồn tại.",
  turnoverTierExists: "Bậc doanh thu tồn tại.",
  turnoverTierFull: "Bậc doanh thu vượt quá bậc tối đa.",
  turnoverTierNotExists: "Bậc doanh thu không tồn tại.",
  invalidSettingValue: "Giá trị cài đặt không hợp lệ.",
  turnoverTierNotSet: "Cấp doanh thu chưa được đặt.",
  rebateProcessed: "Chiết khấu đã được xử lý.",
  invalidActionType: "Loại hành động không hợp lệ.",
  invalidRescueCycle: "Chu trình cứu hộ không hợp lệ.",
  invalidPayoutMethod: "Phương thức thanh toán không hợp lệ.",
  invalidTargetGroup: "Nhóm mục tiêu không hợp lệ.",
  rescueExists: "Giải cứu tồn tại.",
  rescueNotExists: "Giải cứu không tồn tại.",
  walletExists: "Ví tồn tại.",
  accountExists: "Tài khoản tồn tại.",
  activeFromGtActiveTo: "Hoạt động từ lớn hơn hoạt động đến.",
  accountNotExists: "ID nhà điều hành không tồn tại.",
  invalidDeposit: "Tiền gửi không hợp lệ.",
  invalidTurnover: "Doanh thu không hợp lệ.",
  providerCodeNotExists: "Mã nhà cung cấp không tồn tại.",
  gameNameExists: "Tên trò chơi tồn tại.",
  gameNameNotExists: "Tên trò chơi không tồn tại.",
  invalidAccountType: "Loại tài khoản không hợp lệ.",
  invalidLoginIdFormat: "Định dạng ID đăng nhập không hợp lệ.",
  invalidReferralCode: "Mã giới thiệu không hợp lệ.",
  firstDepositNotMet: "Tiền gửi đầu tiên không được đáp ứng.",
  newbieNotMet: "Yêu cầu của người mới không được đáp ứng.",
  claimPromoOnlyOnce: "Yêu cầu khuyến mãi chỉ một lần.",
  promotionRequirementNotMet: "Không đáp ứng yêu cầu thăng hạng.",
  withdrawalAmountLteWithholdAmount: "Số tiền rút nhỏ hơn hoặc bằng số tiền khấu lưu.",
  subAccountInactive: "Tài khoản phụ không hoạt động.",
  gameNotSupported: "Trò chơi không được hỗ trợ.",
  startTimeGteEndTime: "Thời gian bắt đầu lớn hơn hoặc bằng thời gian kết thúc.",
  invalidPromotionType: "Loại quảng cáo không hợp lệ.",
  invalidClaimType: "Loại xác nhận quyền sở hữu không hợp lệ.",
  claimLimitExceeded10: "Giới hạn yêu cầu vượt quá 10.",
  verificationFailed: "Xác minh không thành công.",
  claimLimitReached: "Đã đạt đến giới hạn yêu cầu.",
  invalidPromotion: "Quảng cáo không hợp lệ.",
  socialPlatformExists: "Nền tảng xã hội tồn tại.",
  duplicateReview: "Đánh giá trùng lặp.",
  invalidSurveyId: "ID khảo sát không hợp lệ.",
  accountNotBlock: "Tài khoản không bị chặn.",
  walletNotExists: "Ví không tồn tại.",
  socialPlatformNotExists: "Nền tảng xã hội không tồn tại.",
  socialPlatformInactive: "Nền tảng xã hội không hoạt động.",
  accountSocialExists: "Tài khoản xã hội tồn tại.",
  invalidStatus: "Trạng thái không hợp lệ.",
  samePassword: "Cùng mật khẩu.",
  invalidPassword: "Tên người dùng hoặc mật khẩu không hợp lệ.",
  secondaryAccountExists: "Tài khoản phụ tồn tại.",
  invalidSecurityCode: "Mã bảo mật không hợp lệ.",
  accountSocialNotExists: "Tài khoản mạng xã hội không tồn tại.",
  providerInactive: "Nhà cung cấp không hoạt động.",
  gameIdExists: "ID trò chơi tồn tại.",
  gameIdNotExists: "ID trò chơi không tồn tại.",
  parentProviderInactive: "Nhà cung cấp mẹ không hoạt động.",
  betLimitNotExists: "Giới hạn đặt cược không tồn tại.",
  min3Characters: "Tối thiểu 3 ký tự.",
  invalidBankAccType: "Loại tài khoản ngân hàng không hợp lệ.",
  senderBankNotExists: "Ngân hàng người gửi không tồn tại.",
  recipientBankNotExists: "Ngân hàng nhận không tồn tại.",
  affiliateNotExists: "Đặc vụ không tồn tại.",
  redepositedTicket: "Vé nạp lại.",
  invalidDepositType: "Loại tiền gửi không hợp lệ.",
  affiliateInactive: "Đặc vụ không hoạt động.",
  bonusUnavailable: "Tiền thưởng không có sẵn.",
  pendingDeposit: "Đang chờ nạp tiền.",
  noOngoingPromotion: "Không có chương trình khuyến mãi đang diễn ra.",
  iframeNotExists: "IFrame không tồn tại.",
  gameMaintenance: "Bảo trì trò chơi.",
  labelInactive: "Nhãn không hoạt động.",
  invalidDomainType: "Loại miền không hợp lệ.",
  invalidModule: "Mô-đun không hợp lệ.",
  labelFull: "Nhãn đầy.",
  questionExists: "Câu hỏi tồn tại.",
  questionFull: "Câu hỏi đầy đủ.",
  questionNotExists: "Câu hỏi không tồn tại.",
  reviewNotExists: "Đánh giá không tồn tại.",
  invalidDomainGroup: "Nhóm miền không hợp lệ.",
  invalidDateRange: "Phạm vi ngày không hợp lệ.",
  ipAddressNotExists: "Địa chỉ IP không tồn tại.",
  marqueeNotExists: "Marquee không tồn tại.",
  invalidAmount: "Số tiền không hợp lệ.",
  insufficientBalance: "Số dư không đủ.",
  minLimitLtParent: "Giới hạn tối thiểu nhỏ hơn cha mẹ.",
  maxLimitGtParent: "Giới hạn tối đa lớn hơn cha mẹ.",
  startDateGtEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  currencyNotExists: "Tiền tệ không tồn tại.",
  currencyExists: "Tiền tệ tồn tại.",
  noAccumulateWin: "Không có chiến thắng tích lũy.",
  invalidSession: "Phiên không hợp lệ.",
  sessionExpired: "Phiên đã hết hạn.",
  promotionExists: "Quảng cáo tồn tại.",
  invalidCriteria: "Tiêu chí không hợp lệ.",
  promotionNotExists: "Quảng cáo không tồn tại.",
  ticketNotExists: "Vé không tồn tại.",
  duplicateDebitRecord: "Hồ sơ ghi nợ trùng lặp.",
  duplicateCreditRecord: "Hồ sơ tín dụng trùng lặp.",
  debitRecordNotExists: "Hồ sơ ghi nợ không tồn tại.",
  minDepositNotMet: "Tiền gửi tối thiểu không được đáp ứng.",
  duplicateBet: "Đặt cược trùng lặp.",
  invalidProviderCode: "Mã nhà cung cấp không hợp lệ.",
  resultExists: "Kết quả tồn tại.",
  unableSPProcess: "Hệ thống không thể xử lý yêu cầu của bạn.",
  authRequired: "Mã xác thực là bắt buộc.",
  domainExists: "Tên miền đã tồn tại.",
  multiSelectOption: "Vui lòng chọn {fname}",
  invalidDomainFormat: "Định dạng miền không hợp lệ",
  noHttpHttps: "'https://' hoặc 'http://' không được phép.",
  noReservedSubdomain: "Tên miền phụ dành riêng không được phép. Đối với việc sử dụng liên kết tải xuống ứng dụng.",
  operatorInactive: "Người vận hành không hoạt động",
  invalidAccountIdFormat: "Định dạng ID tài khoản không hợp lệ",
  contentIdRequired: "ID menu là bắt buộc",
  themeCodeRequired: "Mã chủ đề là bắt buộc",
  themeNameRequired: "Tên chủ đề là bắt buộc",
  themeColorRequired: "Màu chủ đề là bắt buộc",
  languageRequired: "Ngôn ngữ là bắt buộc",
  positionRequired: "Vị trí là bắt buộc",
  themeContentIdRequired: "Mã nội dung chủ đề là bắt buộc",
  emailRequired: "Email là bắt buộc",
  themeProviderTypeRequired: "Loại nhà cung cấp chủ đề là bắt buộc",
  phoneRequired: "Điện thoại là bắt buộc",
  targetTypeRequired: "Loại mục tiêu là bắt buộc",
  packageTypeRequired: "Loại gói là bắt buộc",
  renewTermRequired: "Gia hạn thời hạn là bắt buộc",
  packagePriceRequired: "Giá trọn gói là bắt buộc",
  packageStatusRequired: "Trạng thái gói là bắt buộc",
  sortKeyRequired: "Khóa sắp xếp là bắt buộc",
  invalidDomainStatus: "Trạng thái miền không hợp lệ",
  invalidCurrency: "Đơn vị tiền tệ không hợp lệ",
  invalidThemeCode: "Mã chủ đề không hợp lệ",
  invalidLanguage: "Ngôn ngữ không hợp lệ",
  invalidPosition: "Vị trí không hợp lệ",
  invalidThemeContent: "Nội dung chủ đề không hợp lệ",
  allParamsSameAsCurrent: "Không có thay đổi",
  invalidThemeColor: "Màu chủ đề không hợp lệ",
  invalidCartStatus: "Trạng thái giỏ hàng không hợp lệ",
  invalidThemeProviderType: "Loại nhà cung cấp chủ đề không hợp lệ",
  themeProviderTypeCannotBeUse: "Không thể sử dụng loại nhà cung cấp chủ đề",
  invalidUserStatus: "Trạng thái người dùng không hợp lệ",
  packageCannotBeRemove: "Gói không thể được tháo ra",
  userStatusIsAlrdSuspend: "Người dùng đã bị tạm ngưng",
  userStatusIsAlrdBlocked: "Người dùng đã bị chặn",
  userStatusIsAlrdActive: "Người dùng đã hoạt động",
  invalidSortType: "Loại sắp xếp không hợp lệ",
  startDateBiggerThanEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc",
  positionCannotBeUse: "Vị trí không thể được sử dụng",
  funcAddContentFailed: "Không thể thêm nội dung",
  funcDeleteContentFailed: "Không thể xóa nội dung",
  funcUpdateContentFailed: "Không cập nhật được nội dung",
  funcAddThemeFailed: "Không thể thêm chủ đề",
  funcDeleteThemeFailed: "Không thể xóa chủ đề",
  funcUpdateThemeFailed: "Không cập nhật chủ đề được",
  funcAddThemeColorFailed: "Không thể thêm màu chủ đề",
  funcDeleteThemeColorFailed: "Không thể xóa màu chủ đề",
  funcUpdateThemeColorFailed: "Không cập nhật được màu chủ đề",
  funcAddLanguageFailed: "Không thể thêm ngôn ngữ",
  funcDeleteLanguageFailed: "Không thể xóa ngôn ngữ",
  funcUpdateLanguageFailed: "Không cập nhật được ngôn ngữ",
  funcAddThemeContentFailed: "Không thể thêm nội dung chủ đề",
  funcDeleteThemeContentFailed: "Không thể xóa nội dung chủ đề",
  funcUpdateThemeContentFailed: "Không cập nhật được nội dung chủ đề",
  funcAddContentPositionFailed: "Không thể thêm vị trí nội dung",
  funcUpdateContentPositionFailed: "Không cập nhật được vị trí nội dung",
  funcDeleteContentPositionFailed: "Không thể xóa vị trí nội dung",
  funcAddThemeProviderTypeFailed: "Không thể thêm loại nhà cung cấp chủ đề",
  funcUpdateThemeProviderTypeFailed: "Không cập nhật được loại nhà cung cấp chủ đề",
  funcDeleteThemeProviderTypeFailed: "Không thể xóa loại nhà cung cấp chủ đề",
  funcAddPackageFailed: "Không thể thêm gói",
  funcUpdatePackageFailed: "Không cập nhật được gói",
  funcDeletePackageFailed: "Không thể xóa gói",
  nicknameRequired: "Biệt danh là bắt buộc",
  accountStatusRequired: "Trạng thái tài khoản là bắt buộc",
  contentIdMaxLength50: "Độ dài tối đa của ID menu là 50",
  positionMaxLength10: "Độ dài tối đa của vị trí là 10",
  contentDescMaxLength200: "Độ dài tối đa của mô tả nội dung là 200",
  domainStatusRequired: "Trạng thái tên miền là bắt buộc",
  funcAddDomainFailed: "Không thể thêm miền",
  funcUpdateDomainFailed: "Không cập nhật tên miền",
  uploadFailed: "Tải lên không thành công!",
  sortKeyMaxLength50: "Độ dài tối đa của phím sắp xếp là 50",
  invalidSortTypeFormat: "Định dạng loại sắp xếp không hợp lệ",
  invalidPackageId: "ID gói không hợp lệ",
  invalidAccountStatusFormat: "Định dạng trạng thái tài khoản không hợp lệ",
  invalidSiteStatusFormat: "Định dạng trạng thái trang web không hợp lệ",
  invalidPackageStatus: "Trạng thái gói không hợp lệ",
  invalidEmailFormat: "Định dạng email không hợp lệ",
  invalidPhoneFormat: "Định dạng điện thoại không hợp lệ",
  languageLengthNotInRange: "Độ dài ngôn ngữ không nằm trong phạm vi (2-5)",
  languageDescriptionMaxLength50: "Độ dài tối đa của mô tả ngôn ngữ là 50",
  remarkMaxLength500: "Nhận xét chiều dài tối đa là 500",
  themeProviderTypeMaxLength50: "Loại nhà cung cấp chủ đề có độ dài tối đa là 50",
  themeNameMaxLength50: "Độ dài tối đa của tên chủ đề là 50",
  themeColorMaxLength20: "Độ dài tối đa của màu chủ đề là 20",
  noSpace: "Không được chứa khoảng cách",
  packageDescEnRequired: "Tên tiếng Anh là bắt buộc",
  packageDescEnMaxLength20: "Tên tiếng Anh độ dài tối đa là 20",
  allParamsIsNull: "Tất cả các tham số đều rỗng",
  contentCannotBeRemove: "Nội dung không thể bị xóa",
  contentDetailsRequired: "Chi tiết nội dung là bắt buộc",
  domainCannotBeUse: "Không thể sử dụng tên miền",
  domainGroupMaxLength20: "Độ dài tối đa của nhóm miền là 20",
  domainGroupRequired: "Nhóm tên miền là bắt buộc",
  domainNameCannotUpdate: "Tên miền không thể cập nhật",
  domainNameMaxLength400: "Độ dài tối đa của tên miền là 400",
  domainsRequired: "Tên miền là bắt buộc",
  domainStatusMaxLength20: "Độ dài tối đa của trạng thái tên miền là 20",
  domainTypeMaxLength10: "Độ dài tối đa của loại miền là 10",
  funcAddThemeContentGroupFailed: "Thêm nhóm nội dung chủ đề không thành công",
  funcDeleteThemeContentGroupFailed: "Xóa nhóm nội dung chủ đề không thành công",
  funcOpsiteUpdateFailed: "Cập nhật Opsite không thành công",
  funcResetAccountPasswordFailed: "Đặt lại mật khẩu tài khoản không thành công",
  funcSiteLanguageUpsertFailed: "Nâng cấp ngôn ngữ trang web không thành công",
  funcSiteThemeContentUpsertFailed: "Cập nhật nội dung chủ đề trang web không thành công",
  funcSiteThemeUpsertFailed: "Cập nhật chủ đề trang web không thành công",
  funcSiteUpdateFailed: "Cập nhật trang web không thành công",
  funcUpdateAccountFailed: "Cập nhật tài khoản không thành công",
  funcUpdateAccountStatusActiveFailed: "Cập nhật trạng thái tài khoản thành hoạt động không thành công",
  funcUpdateAccountStatusCompanyBlockFailed: "Cập nhật trạng thái tài khoản thành khối công ty không thành công",
  funcUpdateAccountStatusSuspendFailed: "Cập nhật trạng thái tài khoản để tạm ngưng không thành công",
  funcUpdateThemeContentGroupFailed: "Cập nhật nhóm nội dung chủ đề không thành công",
  invalidBoDomain: "Tên miền BO không hợp lệ",
  invalidOperatorIdFormat: "Định dạng ID toán tử không hợp lệ",
  invalidOpsite: "Opsite không hợp lệ",
  invalidOpsiteOperator: "Nhà điều hành opsite không hợp lệ",
  invalidOpsiteVersion: "Phiên bản opsite không hợp lệ",
  invalidParentContentInGroup: "Nội dung cha không hợp lệ trong nhóm",
  invalidSite: "Trang web không hợp lệ",
  invalidSiteStatus: "Trạng thái trang web không hợp lệ",
  invalidThemeContentGroup: "Nhóm nội dung chủ đề không hợp lệ",
  languageCannotBeUse: "Không thể sử dụng ngôn ngữ",
  languagesRequired: "Ngôn ngữ là bắt buộc",
  logo1Required: "Logo là bắt buộc",
  notSupportMultiDefault: "Nhiều mặc định không được hỗ trợ",
  operatorIdMaxLength50: "Độ dài tối đa của ID nhà điều hành là 50",
  opsiteNotMatch: "Opsite không khớp",
  packageTypeMaxLength15: "Loại gói chiều dài tối đa là 15",
  parentContentIdCannotSameWithContentId: "ID nội dung dành cho cha mẹ không được giống với ID nội dung",
  phoneNumberRequired: "Số điện thoại là bắt buộc",
  siteIdRequired: "ID trang web là bắt buộc",
  siteNameMaxLength50: "Độ dài tối đa của tên trang web là 50",
  siteNameRequired: "Tên trang web là bắt buộc",
  technicalError: "Lỗi kỹ thuật",
  themeCannotBeRemove: "Chủ đề không thể bị xóa",
  themeCodeCannotBeUse: "Không thể sử dụng mã chủ đề",
  themeCodeMaxLength20: "Độ dài tối đa của mã chủ đề là 20",
  themeColorCannotBeRemove: "Không thể xóa màu chủ đề",
  themeColorCannotBeUse: "Không thể sử dụng màu chủ đề",
  themeContentCannotBeUse: "Không thể sử dụng nội dung chủ đề",
  themeContentGroupCannotBeUse: "Không thể sử dụng nhóm nội dung chủ đề",
  themeContentGroupDescriptionMaxLength50: "Độ dài tối đa mô tả nhóm nội dung chủ đề là 50",
  themeContentGroupMaxLength20: "Độ dài tối đa của nhóm nội dung chủ đề là 20",
  themeContentGroupRequired: "Nhóm nội dung chủ đề là bắt buộc",
  themeNameCannotBeUse: "Không thể sử dụng tên chủ đề",
  userHaventVerifyThisBefore: "Người dùng chưa xác minh điều này trước đây",
  isDefaultTrueRequired: "Ngôn ngữ phải có 1 mặc định",
  accountIdMaxLength50: "Độ dài tối đa của ID người dùng là 50",
  headBodyScriptEitherOne: "Vui lòng nhập Kịch bản chính hoặc Kịch bản thân",
  alphaOrNum: "Chỉ phải là bảng chữ cái hoặc số",
  phoneValid: "Vui lòng nhập số điện thoại hợp lệ",
  permittedAmountRequired: "Số tiền cho phép là bắt buộc",
  ignoreRiskRequired: "Bỏ qua rủi ro là bắt buộc",
  paymentDescRequired: "Mô tả thanh toán là bắt buộc",
  gameTypeRequired: "Loại trò chơi là bắt buộc",
  statusRequired: "Trạng thái là bắt buộc",
  payoutIdRequired: "Id thanh toán là bắt buộc",
  commNotExists: "Hoa hồng không tồn tại",
  parentCommNotExists: "Ủy ban phụ huynh không tồn tại",
  carryOverNotExists: "Carry over không tồn tại",
  hotGameExists: "Trò chơi nóng đã tồn tại",
  commSportsExceededParent: "Hoa hồng cho thể thao vượt quá phụ huynh",
  commSlotsExceededParent: "Hoa hồng cho các vị trí vượt quá cha mẹ",
  commLivecasinoExceededParent: "Hoa hồng cho sòng bạc trực tiếp vượt quá cha mẹ",
  commCockfightExceededParent: "Hoa hồng chọi gà vượt quá cha mẹ",
  commOthersExceededParent: "Hoa hồng cho những người khác vượt quá cha mẹ",
  hotGameNotExists: "Trò chơi nóng không tồn tại",
  noSecurityDeposit: "Không có quỹ bảo đảm",
  exchangeRateNotExists: "Tỷ giá hối đoái không tồn tại",
  insufficientSecurityDeposit: "Không đủ quỹ bảo đảm",
  duplicateDomain: "Tên miền trùng lặp",
  contactEmailNotExists: "Email liên hệ không tồn tại",
  featuredGameNotExists: "Trò chơi tính năng không tồn tại",
  newGameNotExists: "Trò chơi mới không tồn tại",
  popularGameNotExists: "Trò chơi phổ biến không tồn tại",
  featuredGameExists: "Trò chơi tính năng đã tồn tại",
  newGameExists: "Trò chơi mới đã tồn tại",
  popularGameExists: "Trò chơi phổ biến đã tồn tại",
  rebateNotExists: "Chiết khấu không tồn tại",
  riskyMember: "Thành viên mạo hiểm",
  ipRestricted: "IP bị hạn chế",
  notSupportedBank: "Ngân hàng không được hỗ trợ.",
  requestTooFrequent: "Yêu cầu quá thường xuyên.",
  paymentOptionNotExists: "Tùy chọn thanh toán không tồn tại.",
  earningIdRequired: "Yêu cầu ID thu nhập.",
  ptOnRequired: "PT bắt buộc.",
  ptRequired: "Yêu cầu PT.",
  userIdRequired: "Yêu cầu ID người dùng.",
  businessIdRequired: "Yêu cầu ID doanh nghiệp.",
  subAccountIdRequired: "Yêu cầu ID tài khoản phụ.",
  sourceAccountIdRequired: "Yêu cầu ID tài khoản nguồn.",
  targetAccountIdRequired: "Yêu cầu ID tài khoản mục tiêu.",
  ticketTaken: "Vé đã được lấy",
  ticketNotTaken: "Vé không bị lấy",
  invalidPt: "PT không hợp lệ",
  topupIdRequired: "Yêu cầu nạp id",
  promotionMemberLogNotExists: "không tồn tại nhật ký thành viên khuyến mãi",
  paymentOptionInactive: "Tùy chọn thanh toán không hoạt động",
  invalidCartStatusFormat: "Định dạng trạng thái giỏ hàng không hợp lệ",
  requestIncompleted: "Yêu cầu chưa hoàn thành",
  unknownError: "Đã xảy ra lỗi không xác định",
  cartIdRequired: "ID giỏ hàng là bắt buộc",
  stepNameRequired: "Tên bước là bắt buộc",
  invalidCart: "Giỏ hàng không hợp lệ",
  invalidStepName: "Tên bước không hợp lệ",
  cartHaventSetupComplete: "Giỏ hàng chưa thiết lập xong",
  funcCartCreateFailed: "Không thể tạo giỏ hàng",
  funcCartUpdateFailed: "Không cập nhật giỏ hàng",
  funcSiteCreateFailed: "Không thể tạo trang web",
  funcCartPurchasedUpdateFailed: "Không cập nhật được giỏ hàng đã mua",
  invalidPasswordFormat: "Định dạng mật khẩu không hợp lệ",
  currencyCodeRequired: "Tiền tệ là bắt buộc",
  funcCartLanguageUpsertFailed: "Nâng cấp ngôn ngữ giỏ hàng chức năng không thành công",
  invalidUserIdFormat: "Định dạng ID người dùng không hợp lệ",
  operatorPasswordRequired: "Mật khẩu nhà điều hành là bắt buộc",
  funcCartOperatorInfoUpsertFailed: "Thông tin người vận hành giỏ chức năng không thành công",
  invalidOperatorPasswordFormat: "Định dạng mật khẩu nhà điều hành không hợp lệ",
  operatorIdCannotBeUse: "Không thể sử dụng ID nhà điều hành",
  siteNameLengthNotInRange: "Độ dài tên trang web không nằm trong phạm vi",
  userIdCannotBeUse: "Không thể sử dụng ID người dùng",
  siteIdAlrdExist: "ID trang web đã tồn tại",
  operatorIdAlrdExist: "ID người vận hành đã tồn tại",
  externalIdAlrdExist: "ID bên ngoài đã tồn tại",
  opsiteContentAlrdExist: "Nội dung chủ đề nội dung trang web đã tồn tại",
  opsiteLanguageAlrdExist: "Ngôn ngữ nội dung trang web đã tồn tại",
  boAccountAlrdExist: "Tài khoản BO đã tồn tại",
  boAccountProfileAlrdExist: "Hồ sơ tài khoản BO đã tồn tại",
  boAccountLoginAlrdExist: "Đăng nhập tài khoản BO đã tồn tại",
  funcCartThemeCodeUpsertFailed: "Không thể cập nhật chủ đề giỏ hàng",
  funcCartThemeColorUpsertFailed: "Không thể nâng cấp màu giỏ hàng",
  funcOpsiteCreateFailed: "Không thể tạo nội dung trang web",
  alphabetValid: "Phải có ít nhất một chữ hoa và chữ thường",
  numberValid: "Phải có ít nhất một số",
  symbolValid: "Phải có ít nhất một ký hiệu",
  credentialNotSet: "Thông tin đăng nhập chưa được đặt",
  validBankAccFormat: "Số tài khoản ngân hàng không hợp lệ. Định dạng",
  moreThan: "{fname} phải nhỏ hơn hoặc bằng {fname2}",
  lessThan: "{fname} phải lớn hơn hoặc bằng {fname2}.",
  bankAccountNotAvailable: "Tài khoản ngân hàng không khả dụng.",
  insufficientCredit: "Tín dụng không đủ",
  enableRequired: "Bật là bắt buộc.",
  funcAddGameFailed: "Không thể thêm trò chơi.",
  funcAddGameRewardByBatchFailed: "Không thể thêm phần thưởng trò chơi theo lô.",
  funcAddGameRewardFailed: "Không thể thêm phần thưởng trò chơi.",
  funcAddGameTemplateFailed: "Không thể thêm mẫu trò chơi.",
  funcAddLayoutTemplateFailed: "Không thể thêm mẫu bố cục.",
  funcAddOperatorGameFailed: "Không thể thêm trò chơi điều khiển.",
  funcAddOperatorMemberWalletFailed: "Không thể thêm ví thành viên nhà điều hành.",
  funcDeleteGameFailed: "Không thể xóa trò chơi.",
  funcDeleteGameRewardFailed: "Không thể xóa phần thưởng trò chơi.",
  funcDeleteGameTemplateFailed: "Không thể xóa mẫu trò chơi.",
  funcDeleteLayoutTemplateFailed: "Không thể xóa mẫu bố cục.",
  funcDeleteOperatorGameFailed: "Không thể xóa trò chơi người điều khiển.",
  funcUpdateGameFailed: "Không cập nhật được trò chơi.",
  funcUpdateGameRewardFailed: "Không cập nhật phần thưởng trò chơi được.",
  funcUpdateGameTemplateFailed: "Không cập nhật được mẫu trò chơi.",
  funcUpdateLayoutTemplateFailed: "Không cập nhật được mẫu bố cục.",
  funcUpdateOperatorGameFailed: "Không cập nhật được trò chơi của người điều khiển.",
  gameCannotBeRemove: "Trò chơi không thể bị xóa.",
  gameNameCannotBeUse: "Không thể sử dụng tên trò chơi.",
  gameNameMaxLength150: "Tên trò chơi tối đa phải là 150 ký tự.",
  gameRewardCannotBeUse: "Phần thưởng trò chơi không thể được sử dụng.",
  gameRewardLimitExceeded: "Vượt quá giới hạn phần thưởng trò chơi.",
  gameTemplateExist: "Mẫu trò chơi đã tồn tại.",
  gameTypeMaxLength20: "Loại trò chơi tối đa phải là 20 ký tự.",
  invalidGame: "Trò chơi không hợp lệ.",
  invalidGameReward: "Phần thưởng trò chơi không hợp lệ.",
  invalidGameTemplate: "Mẫu trò chơi không hợp lệ.",
  invalidMemberWallet: "Ví thành viên không hợp lệ.",
  invalidOperatorGame: "Trò chơi tổng đài viên không hợp lệ.",
  invalidRewardProbability: "Xác suất phần thưởng không hợp lệ.",
  invalidTemplate: "Mẫu không hợp lệ.",
  maxGameRewardRequired: "Phần thưởng trò chơi tối đa là bắt buộc.",
  maxMiniGameRewardRequired: "Cần có phần thưởng tối đa cho trò chơi nhỏ.",
  memberWalletAlrdExist: "Ví thành viên đã tồn tại.",
  operatorGameCannotBeUse: "Không thể sử dụng trò chơi người điều hành.",
  operatorGameIdRequired: "ID trò chơi của nhà điều hành là bắt buộc.",
  rewardCodeMaxLength20: "Mã phần thưởng tối đa phải là 20 ký tự.",
  rewardCodeRequired: "Mã phần thưởng là bắt buộc.",
  rewardCurrencyMaxLength5: "Tiền thưởng tối đa phải là 5 ký tự.",
  rewardCurrencyRequired: "Tiền thưởng là bắt buộc.",
  rewardDescriptionMaxLength100: "Mô tả phần thưởng tối đa phải là 100 ký tự.",
  rewardNameMaxLength50: "Tên phần thưởng tối đa phải là 50 ký tự.",
  rewardProbabilityRequired: "Xác suất phần thưởng là bắt buộc.",
  rewardRequired: "Phần thưởng là bắt buộc.",
  selectedTemplateMaxLength30: "Mẫu được chọn tối đa phải là 30 ký tự.",
  selectedTemplateRequired: "Mẫu đã chọn là bắt buộc.",
  success: "Thành công.",
  templateCannotBeRemove: "Mẫu không thể bị xóa.",
  templateCodeCannotBeUse: "Không thể sử dụng mã mẫu.",
  templateCodeMaxLength30: "Mã mẫu phải có tối đa 30 ký tự.",
  templateCodeRequired: "Mã mẫu là bắt buộc.",
  templateNameMaxLength50: "Tên mẫu phải có tối đa 50 ký tự.",
  tokenRequestRequired: "Yêu cầu mã thông báo là bắt buộc.",
  tokenRequired: "Token là bắt buộc.",
  mustMoreThan: "{fname} phải lớn hơn {fvalue}",
  mustMoreThanOrEqual: "{fname} phải lớn hơn hoặc bằng {fvalue}",
  tokenInvalid: "Nhập mã thông báo không hợp lệ tại {khóa}",
  cashInvalid: "Tiền mặt đầu vào không hợp lệ tại {khóa}",
  atLeastOneRequired: "Yêu cầu ít nhất một",
  cash1To7Required: "Tiền mặt từ 1 đến 7 là bắt buộc",
  cash1To6Required: "Yêu cầu tiền mặt từ 1 đến 6",
  cash1To5Required: "Tiền mặt từ 1 đến 5 là bắt buộc",
  cash1To4Required: "Yêu cầu tiền mặt từ 1 đến 4",
  cash1To3Required: "Tiền mặt từ 1 đến 3 là bắt buộc",
  cash1To2Required: "Tiền mặt 1 đến 2 là bắt buộc",
  cash1Required: "Tiền mặt 1 là bắt buộc",
  token1To7Required: "Token 1 đến 7 là bắt buộc",
  token1To6Required: "Token 1 đến 6 là bắt buộc",
  token1To5Required: "Token 1 đến 5 là bắt buộc",
  token1To4Required: "Token 1 đến 4 là bắt buộc",
  token1To3Required: "Token 1 đến 3 là bắt buộc",
  token1To2Required: "Token 1 đến 2 là bắt buộc",
  token1Required: "Token 1 là bắt buộc",
  cycleRequired: "Chu kỳ là bắt buộc",
  targetAmountRequired: "Số tiền mục tiêu là bắt buộc",
  gamifyIdRequired: "Cần có ID phần thưởng",
  gamifyMemberProcessed: "Phần thưởng thành viên đã được xử lý",
  gamifyNotExists: "Phần thưởng không tồn tại",
  gamifyInactive: "Phần thưởng không hoạt động",
  invalidCycle: "Chu kỳ không hợp lệ",
  memberIdMaxLength50: "ID thành viên không được vượt quá 50 ký tự",
  funcAddGameWalletFreeCreditFailed: "Không thể thêm tín dụng miễn phí vào ví trò chơi",
  funcUpdateOperatorMemberWalletBalanceFailed: "Không cập nhật được số dư ví thành viên nhà điều hành",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Không cập nhật được số dư ví thành viên nhà điều hành theo số tiền bị đóng băng",
  mustHaveBothAlphaNumOnly: "Chỉ sử dụng bảng chữ cái và số, với ít nhất một trong số mỗi loại.",
  setupGameRewardBeforeEnable: "Vui lòng thiết lập phần thưởng trò chơi trước khi kích hoạt.",
  rewardProbabilityMustNotAllZero: "Xác suất phần thưởng không được tất cả bằng không.",
  totalRewardProbabilityCannotOver100: "Tổng xác suất phần thưởng không được vượt quá 100.",
  credential1To2Required: "Cần có chứng chỉ từ 1 đến 2.",
  credential1To4Required: "Cần có chứng chỉ từ 1 đến 4.",
  newRemarkRequired: "Nhận xét là bắt buộc.",
  notSupportedWithdrawalPG: "Cổng thanh toán rút tiền không được hỗ trợ.",
  prizeInvalid: "Dữ liệu giải thưởng không hợp lệ tại {key}",
  exceedMaxCampaignCount: "Vượt quá số lượng chiến dịch bảng xếp hạng tối đa.",
  leaderboardCampaignEnded: "Chiến dịch bảng xếp hạng đã kết thúc.",
  leaderboardCampaignStarted: "Chiến dịch bảng xếp hạng đã bắt đầu",
  leaderboardCampaignSettled: "Chiến dịch bảng xếp hạng đã kết thúc",
  pleaseSelectUpToNoPhone: "Vui lòng chọn tối đa {fname} số điện thoại.",
  phoneNotAvailable: "Điện thoại không khả dụng.",
  batchExpired: "Lô đã hết hạn.",
  remarkNotSame: "Ghi chú không khớp",
  partnerIdRequired: "Yêu cầu ID đối tác",
  partnerNotExists: "Đối tác không tồn tại",
  urgencyRequired: "Yêu cầu mức độ khẩn cấp",
  groupSizeRequired: "Yêu cầu kích thước nhóm",
  inactiveDaysRequired: "Yêu cầu số ngày không hoạt động",
  idRequired: "Yêu cầu ID",
  expiryRequired: "Yêu cầu ngày hết hạn",
  batchIdRequired: "Yêu cầu ID lô",
  requestDateRequired: "Yêu cầu ngày yêu cầu",
  requestByRequired: "Yêu cầu người yêu cầu",
  cpiIdRequired: "Yêu cầu CPI ID",
  assigneeRequired: "Yêu cầu người được giao",
  phoneNotAvailable: "Điện thoại không khả dụng",
  liveChatNotExists: "Trò chuyện trực tiếp không tồn tại",
  resultNotExists: "Kết quả không tồn tại",
  lastLaunchFundTransfer: "Chuyển tiền khởi chạy lần cuối",
  alreadyRegistered: "Đã đăng ký",
  invalidId: "ID không hợp lệ",
  batchExpired: "Lô đã hết hạn",
  teleCalling: "Gọi điện thoại",
  invalidUrgency: "Mức độ khẩn cấp không hợp lệ",
  appTypeRequired: "Yêu cầu loại ứng dụng",
  invalidAppType: "Loại ứng dụng không hợp lệ",
  appLinkRequired: "Yêu cầu liên kết ứng dụng",
  invalidDomain: "Tên miền không hợp lệ",
  existEndDateGtEndDate: "Ngày kết thúc hiện tại muộn hơn ngày kết thúc mới",
  newRemark2Required: "Yêu cầu ghi chú 2 mới",
  remark2NotSame: "Ghi chú 2 không khớp",
  remark2Required: "Yêu cầu ghi chú 2",
  nameRequired: "Yêu cầu tên",
  aiAssistantNotExists: "Trợ lý AI không tồn tại",
  aiAssistantInactive: "Trợ lý AI không hoạt động",
  phoneStartWithVND: "Số điện thoại phải bắt đầu bằng 84",
  otherActiveLiveChat: "Có LiveChat khác đang hoạt động",
  whiteLabelRequired: "Cần White Label",
  invalidWhiteLabel: "White Label không hợp lệ",
  baseRateDepositRequired: "Yêu cầu tỷ lệ cơ bản của tiền gửi",
  revisionRequired: "Yêu cầu điều chỉnh",
  typeDescRequired: "Yêu cầu mô tả loại",
  riskWeightRequired: "Yêu cầu trọng số rủi ro",
  linkageTypeRequired: "Yêu cầu loại liên kết",
  valueRequired: "Yêu cầu giá trị",
  baseRateWithdrawalRequired: "Yêu cầu tỷ lệ cơ bản của rút tiền",
  sourceIdRequired: "Yêu cầu ID nguồn",
  targetIdRequired: "Yêu cầu ID đích",
  linkageTypeNotExists: "Loại liên kết không tồn tại",
  phoneStartWithMYR: "Số điện thoại phải bắt đầu bằng 60",
  minWithdrawalAmount100: "Số tiền rút tối thiểu là 100",
  invalidReward: "Phần thưởng không hợp lệ",
  noRow: "Không có dòng",
  credentialRequired: "Cần thông tin xác thực",
  settlementIdRequired: "Cần Settlement ID",
  settlementDateRequired: "Cần ngày settlement",
  newCryptoAddressRequired: "Cần địa chỉ crypto mới",
  cryptoAddressRequired: "Cần địa chỉ crypto",
  settlementTypeRequired: "Cần loại settlement",
  chatProviderRequired: "Cần nhà cung cấp chat",
  countRequired: "Cần số lượng",
  voucherCodeRequired: "Cần mã voucher",
  eventTypeRequired: "Cần loại sự kiện",
  viewTypeRequired: "Cần loại hiển thị",
  actionTypeRequired: "Cần loại hành động",
  thresholdRequired: "Cần ngưỡng",
  missionIdRequired: "Cần Mission ID",
  ruleIdRequired: "Cần Rule ID",
  aggregatorRequired: "Cần aggregator",
  rebateIdRequired: "Cần Rebate ID",
  liveChatExists: "Livechat này đã tồn tại",
  triggerNotExists: "Trigger không tồn tại",
  missionRuleNotExists: "Mission rule không tồn tại",
  invalidVoucherCode: "Mã voucher không hợp lệ",
  invalidRebateType: "Loại rebate không hợp lệ",
  invalidSettlementType: "Loại settlement không hợp lệ",
  missionNotExists: "Mission không tồn tại",
  settlementTypeNotExists: "Loại settlement không tồn tại",
  parentTriggerInactive: "Trigger cha không hoạt động",
  parentMissionInactive: "Mission cha không hoạt động",
  missionRuleNotSet: "Chưa thiết lập mission rule",
  invalidCreditType: "Loại credit không hợp lệ",
  cryptoDisabled: "Crypto đã bị vô hiệu hóa",
  depositExists: "Deposit đã tồn tại",
  parentSettlementTypeNotExists: "Loại settlement cha không tồn tại",
  accessControlNotExists: "Access control không tồn tại",
  cryptoAccountFull: "Tài khoản crypto đầy",
  cryptoAccountExists: "Tài khoản crypto đã tồn tại",
  cryptoAccountNotExists: "Tài khoản crypto không tồn tại",
  settlementNotAvailable: "Settlement không khả dụng",
  settlementProcessed: "Settlement đã xử lý",
  cryptoAccountInactive: "Tài khoản crypto không hoạt động",
  leadIdRequired: "Cần Lead ID",
  failedToCreateFreeRound: "Tạo Free Round thất bại.",
  failedToGetFreeRound: "Không thể lấy Free Round.",
  failedToGetFreeRoundGameList: "Không thể lấy danh sách trò chơi Free Round.",
  tierFull: "Cấp độ đã đầy",
  tierNotExists: "Cấp độ không tồn tại",
  ticketTypeRequired: "Loại Ticket là bắt buộc",
  invalidTicketType: "Loại Ticket không hợp lệ",
  positionRequired: "Vị trí là bắt buộc",
  invalidPosition: "Vị trí không hợp lệ",
  invalidBonusRate: "Tỷ lệ thưởng không hợp lệ",
  minRequired: "Giá trị tối thiểu là bắt buộc",
  maxRequired: "Giá trị tối đa là bắt buộc",
  minGtMax: "Giá trị tối thiểu lớn hơn giá trị tối đa.",
  sessionExists: "Phiên đã tồn tại",
  sessionOverlaps: "Phiên bị chồng lấp",
  sessionIdRequired: "ID Phiên là bắt buộc",
  sessionNotExists: "Phiên không tồn tại",
  nameExists: "Tên đã tồn tại",
  sessionElapsed: "Phiên đã kết thúc",
  validUrl: "Vui lòng nhập URL hợp lệ",
  minBalanceNotMet: "Chưa đạt số dư tối thiểu",
  validSlugFormat: "Định dạng slug không hợp lệ",

  failedToCancelFreeRound: "Không thể hủy vòng chơi miễn phí.",
  failedToGetFreeRoundLineBet: "Không thể lấy cược dòng của vòng chơi miễn phí.",
};